









































































import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'

@Component

export default class ComponentModalSolicitacaoCirurgiaQuantidade extends Vue {
  @Prop({ required: false, default: false }) disabled: boolean

  $refs!: {
    quantidadeForm: any,
  }

  quantidadeRules: any = {
    valid: true,
    quantidade: [
      v => !!v || 'Campo obrigatório.',
    ],
    lateralidade: [],
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getShowModalQuantidade() {
    const show = this.getSolicitacaoStore.modalSolicitacaoCirurgia.showQuantidade

    // if (show && [null, undefined, true].includes(this.getProcedimentoQuantidade.temLateralidade)) {
    // Force laterality in all cases... [TEMPORARY]
    if (show) {
      this.quantidadeRules.lateralidade.push(v => !!v || 'Campo obrigatório.')
    }

    return show
  }

  get templateLateralidade() {
    // Force laterality in all cases... [TEMPORARY]
    return true
    // if (this.getSolicitacaoCirurgiaStore.currentTemplate
    //     && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario
    //     && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.lateralidade) {
    //   const { lateralidadeEmProcedimento, exigeLateralidadeEmTodosOsProcedimentos } = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.lateralidade
    //   return exigeLateralidadeEmTodosOsProcedimentos || this.getProcedimentoQuantidade.temLateralidade
    // }
    // return false
  }

  set getShowModalQuantidade(value: boolean) {
    this.getSolicitacaoStore.setShowModalProcedimentoQuantidade(value)
  }

  get getProcedimentoQuantidade() {
    return this.getSolicitacaoStore.procedimentoQuantidade
  }

  onlyNumber(input) {
    const numberPattern = /\d+/g
    const result = input.key.match(numberPattern)
    if (!result) {
      input.preventDefault()
      return false
    }
    return true
  }

  async save() {
    if (this.$refs.quantidadeForm.validate()) {
      this.getSolicitacaoStore.setShowModalProcedimentoQuantidade(false)
      await this.addSelectedPrincipal(this.getSolicitacaoStore.procedimentoQuantidade)
      this.getSolicitacaoStore.clearProcedimentoQuantidade()
      this.$refs.quantidadeForm.reset()
      this.$refs.quantidadeForm.resetValidation()
    }
  }

  closeModalQuantidade() {
    this.getSolicitacaoStore.setShowModalProcedimentoQuantidade(false)
    this.getSolicitacaoStore.clearProcedimentoQuantidade()
    this.$refs.quantidadeForm.reset()
    this.$refs.quantidadeForm.resetValidation()
  }

  @Emit('addSelectedPrincipal')
  async addSelectedPrincipal(value) {
    //
  }

  toggleBodyOverflow(isOpen: Boolean) {
    const html = document.querySelector('body')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
      }
    }
  }
}

